module.exports = __webpack_public_path__ + "static/media/Mask group.4bc0e9e1.png";